var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign"},[_vm._v("\n  签约："+_vm._s(_vm.moment(_vm.followItem.signDate).format("YYYY/MM/DD"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }